<template>
<div class="relative">
  <div class="vx-navbar-wrapper navbar-full p-0">
    <vs-navbar class="navbar-custom navbar-skelton" :class="navbarClasses"  :style="navbarStyle" :color="navbarColor">

      <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />

      <router-link tag="div" to="/" class="vx-logo cursor-pointer mx-auto flex items-center">
        <logo  />
      </router-link>
      
      <vx-tooltip text="مركز المساعدة" position="bottom" delay=".2s">
        <help-center />
      </vx-tooltip>

      <vx-tooltip text="البحث المتقدم" position="bottom" delay=".2s">
        <advanced-search />
      </vx-tooltip>

      <vx-tooltip text="الإشعارات" position="bottom" delay=".2s">
        <notification-drop-down />
      </vx-tooltip>

      <accounts-drop-down />

      <profile-drop-down />

    </vs-navbar>
  </div>
</div>
</template>

<script>
import Bookmarks            from './components/Bookmarks.vue'
import SearchBar            from './components/SearchBar.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import AccountsDropDown      from './components/AccountsDropDown.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'
import AdvancedSearch      from './components/AdvancedSearch.vue'
import Logo                 from '../Logo.vue'
import HelpCenter from './components/HelpCenter'
import { mapActions } from "vuex"

export default {
  name: 'the-navbar-horizontal',
  props: {
    logo: { type: String                                                                                                          },
    navbarType: {
      type: String,
      required: true
    }
  },
  components: {
    Logo,
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    AccountsDropDown,
    ProfileDropDown,
    AdvancedSearch,
    HelpCenter
  },
  computed: {
    navbarColor () {
      let color = '#fff'
      if (this.navbarType === 'sticky') color = '#f7f7f7'
      else if (this.navbarType === 'static') {
        if (this.scrollY < 50) {
          color = '#f7f7f7'
        }
      }

      if (this.isThemedark === 'dark') {
        if (color === '#fff') {
          color = '#10163a'
        } else {
          color = '#262c49'
        }
      }

      return color
    },
    isThemedark ()          { return this.$store.state.theme                                                                       },
    navbarStyle ()          { return this.navbarType === 'static' ? {transition: 'all .25s ease-in-out'} : {}                      },
    navbarClasses ()        { return this.scrollY > 5 && this.navbarType === 'static' ? null : 'd-theme-dark-light-bg shadow-none' },
    scrollY ()              { return this.$store.state.scrollY                                                                     },
    verticalNavMenuWidth () { return this.$store.state.verticalNavMenuWidth                                                        },
    windowWidth ()          { return this.$store.state.windowWidth                                                                 }
  },
  methods: {
    ...mapActions('', ['']),
  }
}

</script>

// <style lang="scss">
// @media (max-width: 576px){
//   .vx-navbar-wrapper {
//     left: -25px;
//   }
// }
// </style>
